import React, { useState } from 'react';
import { connect } from 'react-redux';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { Text, Theme, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';
import store from '../../redux/store.js';

const NameBlock = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 0.3,
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        flex: 0.5
    },
    [theme.breakpoints.down('570')]: {
        flex: 0.6
    },
    [theme.breakpoints.down('460')]: {
        flex: 1
    }
}));

const DataBlock = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 0.8,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('460')]: {
        flex: 0.8
    }
}));

/**
 * 
 * @returns 
 */
const PersonBlock = ({ edit, remove, firstname, relationship, percentage, testid, id, type, status, iconCustomStyle, meta }) => {
    const whitelabel = store.getState().whitelabel;

    const [ state, setState ] = useState({ anchorEl: null });
            
    /**
     * 
     * @param {*} event 
     */
    const _handleMenuClick = (event) => {
        setState({ anchorEl: event.currentTarget });
    };
       
    /**
     * 
     */
    const _handleCloseMenu = () => {
        setState({ anchorEl: null });
    };

    const blockRow = {
        alignItems: 'center',
        backgroundColor: Theme.colors.surface,
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        height: 60,
        marginBottom: 5
    };

    return (
        <div id={ id || testid } style={ blockRow }>
            <NameBlock onClick={ type !== 'dependent' ? edit : null } style={{ backgroundColor: whitelabel.lightColor || Theme.colors.lightBlue }}>
                <Text medium>{ firstname }</Text>

                <Text
                    tiny
                    light
                >
                    { localizationMaps.fromEnglish("relationships", relationship) }
                </Text>
            </NameBlock>

            <DataBlock>
                {
                    percentage &&
                            <Text medium>{`${ percentage }%`}</Text>
                }

                { // hide the menu options for the SOGS group
                    (meta.groupNum === "62250" && type === 'dependent') ?
                        null
                        :
                        <IconButton
                            aria-label="Edit"
                            onClick={_handleMenuClick}
                            sx={iconCustomStyle}
                            
                        >
                            <MoreVertIcon />
                        </IconButton>
                }

                {
                    type === 'dependent' && status &&
                            <Text
                                small
                                margin="0 10px"
                                color={ status === 'Active' ? Theme.colors.brandGreen : status === 'Disabled' ? Theme.colors.red : Theme.colors.darkGrey }
                                uppercase
                            >
                                { localizationMaps.fromEnglish("statuses", status) }
                            </Text>
                }
            </DataBlock>

            <Menu
                anchorEl={ state.anchorEl }
                open={Boolean(state.anchorEl)}
                onClose={ _handleCloseMenu }
                onClick={ _handleCloseMenu }
                disableAutoFocusItem={ true }
                sx={{ '& .MuiPaper-root': {
                    borderRadius: '8px',
                    minWidth: 250
                } }}
                anchorOrigin={ { vertical: "top", horizontal: "left" } } 
            >
                <MenuItem onClick={ edit } > 
                    <Text
                        medium
                        display="inline"
                    >
                        { i18n.t(tokens.buttons.edit) }
                    </Text>
                </MenuItem>

                <MenuItem onClick={ remove }>
                    <Text
                        medium
                        display="inline"
                    >
                        { i18n.t(tokens.buttons.remove) }
                    </Text>
                </MenuItem>
            </Menu>
        </div>
    );
};

/**
 * Map state to props
 * @param {Object} state - Redux state
 * @returns {Object}
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta
});

export default connect(mapStateToProps)(PersonBlock);